<template xmlns:v-popover="http://www.w3.org/1999/xhtml">
  <span>
    <el-popover ref="popover" placement="top-start" trigger="hover"
                :title="title" :logo="logo" width="210" popper-class="qr-popper"
                @show="showQr">
      <canvas v-if="content" :id="id"></canvas>
      <p v-else class="popper-text-center">暂无</p>
    </el-popover>
  <a v-popover:popover class="qr-text">{{text}}</a>
  </span>
</template>

<script>
import QrCodeWithLogo from 'qr-code-with-logo'

export default {
  name: 'qr-popover-box',
  props: {
    title: {},
    content: {},
    text: {},
    logo: ''
  },
  data () {
    return {
      id: 'diDing' + Math.random().toString()
    }
  },
  methods: {
    showQr () {
      if (this.logo) {
        QrCodeWithLogo.toCanvas({
          canvas: document.getElementById(this.id),
          content: this.content,
          width: 180,
          logo: {
            src: this.logo,
            borderRadius: 0,
            borderSize: 0.01,
            logoSize: 0.17,
          }
        })
          .catch(e => console.error(e))
      } else {
        QrCodeWithLogo.toCanvas({
          canvas: document.getElementById(this.id),
          content: this.content,
          width: 180,
        })
          .catch(e => console.error(e))
      }
    }
  }
}
</script>

<style lang="less">
  .qr-popper {
    cursor: pointer;
    padding-left: 0;
    .el-popover__title {
      margin-top: 15px;
      text-align: center;
      font-size: 12px;
    }
  }
  .popper-text-center {
    text-align: center;
  }
  .qr-text {
    font-size: 14px;
    color: #1362FF;
    cursor: pointer;
    :hover {
      color: #06b3ff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/QR/qr-popover-box.vue